import {EnumLanguage} from "../EnumLanguage";

export const UIText = {
    actions: {
        add: {
            [EnumLanguage.en]: 'Add',
            [EnumLanguage.ru]: 'Добавить',
            [EnumLanguage.cn]: '添加',
        },
        cancel: {
            [EnumLanguage.en]: 'Cancel',
            [EnumLanguage.ru]: 'Отменить',
            [EnumLanguage.cn]: '取消',
        },
        create: {
            [EnumLanguage.en]: 'Create',
            [EnumLanguage.ru]: 'Создать',
            [EnumLanguage.cn]: '创建'
        },
        update: {
            [EnumLanguage.en]: 'Update',
            [EnumLanguage.ru]: 'Обновить',
            [EnumLanguage.cn]: '刷新'
        },
        save: {
            [EnumLanguage.en]: 'Save',
            [EnumLanguage.ru]: 'Сохранить',
            [EnumLanguage.cn]: '救'
        },
        back: {
            [EnumLanguage.en]: 'Back',
            [EnumLanguage.ru]: 'Вернуться',
            [EnumLanguage.cn]: '返回'
        },
        logout: {
            [EnumLanguage.en]: 'Logout',
            [EnumLanguage.ru]: 'Выйти',
            [EnumLanguage.cn]: '登出'
        },
    },
    nav: {
        aboutSystem: {
            [EnumLanguage.en]: "About the system",
            [EnumLanguage.ru]: "О системе",
            [EnumLanguage.cn]: "关于系统",

        },
        demo: {
            [EnumLanguage.en]: "Demo",
            [EnumLanguage.ru]: "Демо",
            [EnumLanguage.cn]: "演示",
        },
        price: {
            [EnumLanguage.en]: "Price",
            [EnumLanguage.ru]: "Стоимость",
            [EnumLanguage.cn]: "价格",

        },
        instructions: {
            [EnumLanguage.en]: "Instructions",
            [EnumLanguage.ru]: "Инструкции",
            [EnumLanguage.cn]: "指示",
        },
        educationalProgram: {
            [EnumLanguage.en]: "Educational program",
            [EnumLanguage.ru]: "Образовательная программа",
            [EnumLanguage.cn]: "教育计划",
        },
        contacts: {
            [EnumLanguage.en]: "Contacts",
            [EnumLanguage.ru]: "Контакты",
            [EnumLanguage.cn]: "联系人",
        },
        main: {
            [EnumLanguage.en]: "Home",
            [EnumLanguage.ru]: "Главная",
            [EnumLanguage.cn]: "屋",
        },
        profile: {
            [EnumLanguage.en]: "Profile",
            [EnumLanguage.ru]: "Личный кабинет",
            [EnumLanguage.cn]: "轮廓",
        },
        documents: {
            [EnumLanguage.en]: "Documents",
            [EnumLanguage.ru]: "Документы",
            [EnumLanguage.cn]: "文件",
        },
        cookies: {
            [EnumLanguage.en]: "Cookies",
            [EnumLanguage.ru]: "Cookies",
            [EnumLanguage.cn]: "Cookies",
        },
    },
    mis: {
        [EnumLanguage.en]: "Museum data system",
        [EnumLanguage.ru]: "Музейная информационная система",
        [EnumLanguage.cn]: "博物馆信息系统",
    },
    copyrightFooter: {
        copyright: {
            [EnumLanguage.en]: "© Museum data system",
            [EnumLanguage.ru]: "© Музейная информационная система",
            [EnumLanguage.cn]: "© 博物馆信息系统",
        }
    },
    inputs: {
        placeholder: {
            writeTitle: {
                [EnumLanguage.en]: 'Write title',
                [EnumLanguage.ru]: 'Введите название',
                [EnumLanguage.cn]: "输入标题",
            },
            writePrice: {
                [EnumLanguage.en]: 'Write price',
                [EnumLanguage.ru]: 'Введите стоимость',
                [EnumLanguage.cn]: '输入成本'
            }
        }
    },
    authentication: {
        buttons: {
            login: {
                [EnumLanguage.en]: 'Sign in',
                [EnumLanguage.ru]: 'Войти',
                [EnumLanguage.cn]: '登录'
            },
            logout: {
                [EnumLanguage.en]: 'Logout',
                [EnumLanguage.ru]: 'Выйти',
                [EnumLanguage.cn]: '登出'
            },
            registration: {
                [EnumLanguage.en]: 'Sign up',
                [EnumLanguage.ru]: 'Регистрация',
                [EnumLanguage.cn]: '报名'
            },
            continue: {
                [EnumLanguage.en]: 'Continue',
                [EnumLanguage.ru]: 'Продолжить',
                [EnumLanguage.cn]: '继续'
            },
            haveAccount: {
                [EnumLanguage.en]: 'I already have an account',
                [EnumLanguage.ru]: 'У меня уже есть аккаунт',
                [EnumLanguage.cn]: '我已经有一个帐户'
            },
            forgotPassword: {
                [EnumLanguage.en]: 'Forgot password',
                [EnumLanguage.ru]: 'Не помню пароль',
                [EnumLanguage.cn]: '我已经有一个帐户'
            },
            restore: {
                [EnumLanguage.en]: 'Restore',
                [EnumLanguage.ru]: 'Восстановить',
                [EnumLanguage.cn]: '恢复'
            }
        },
        inputsPlaceholders: {
            password: {
                [EnumLanguage.en]: 'Password',
                [EnumLanguage.ru]: 'Пароль',
                [EnumLanguage.cn]: '密码'
            },
            repeatPassword: {
                [EnumLanguage.en]: 'Repeat password',
                [EnumLanguage.ru]: 'Повторите пароль',
                [EnumLanguage.cn]: '重复输入密码'
            },
            email: {
                [EnumLanguage.en]: 'Email',
                [EnumLanguage.ru]: 'Эл. почта',
                [EnumLanguage.cn]: '电子邮件'
            }
        }
    },
    user: {
        firstName: {
            title: {
                [EnumLanguage.ru]: 'Имя',
                [EnumLanguage.en]: 'Name',
                [EnumLanguage.cn]: '名称'
            }
        },
        lastName: {
            title: {
                [EnumLanguage.ru]: 'Фамилия',
                [EnumLanguage.en]: 'Last name',
                [EnumLanguage.cn]: '姓'
            }
        },
        secondName: {
            title: {
                [EnumLanguage.ru]: 'Отчество',
                [EnumLanguage.en]: 'Second name',
                [EnumLanguage.cn]: '父名的'
            }
        },
        organization: {
            title: {
                [EnumLanguage.ru]: 'Организация',
                [EnumLanguage.en]: 'Organization',
                [EnumLanguage.cn]: '公司'
            }
        },
        email: {
            title: {
                [EnumLanguage.ru]: 'Эл. почта',
                [EnumLanguage.en]: 'Email',
                [EnumLanguage.cn]: '电子邮件'
            }
        },
        phone: {
            title: {
                [EnumLanguage.ru]: 'Телефон',
                [EnumLanguage.en]: 'Phone number',
                [EnumLanguage.cn]: '电话号码'
            }
        },
    },
    contacts: {
        address: {
            [EnumLanguage.ru]: 'Адрес',
            [EnumLanguage.en]: 'Address',
            [EnumLanguage.cn]: '地址'
        },
        phone: {
            [EnumLanguage.ru]: 'Телефон',
            [EnumLanguage.en]: 'Phone',
            [EnumLanguage.cn]: '电话'
        },
        email: {
            [EnumLanguage.ru]: 'Эл. почта',
            [EnumLanguage.en]: 'Email',
            [EnumLanguage.cn]: '邮件'
        },
        schedule: {
            [EnumLanguage.ru]: 'График работы',
            [EnumLanguage.en]: 'Schedule',
            [EnumLanguage.cn]: '日程'
        }
    },
    translate:{
        noTranslate: {
            [EnumLanguage.ru]: 'Перевод отсутсвует',
            [EnumLanguage.en]: 'No translation',
            [EnumLanguage.cn]: '无翻译(No translation)'
        },
    }
}
